import { Data_getInstance23ywm38kal8s as Data_getInstance } from './adapter/GrantSlackAccessMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { GrantSlackAccessMutationSelections_getInstance1cx756k7r0fmp as GrantSlackAccessMutationSelections_getInstance } from './selections/GrantSlackAccessMutationSelections.mjs';
import { GrantSlackAccessMutation_VariablesAdapter_instanceu0vncrzhjn2i as GrantSlackAccessMutation_VariablesAdapter_instance } from './adapter/GrantSlackAccessMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantSlackAccess) {
        this.grantSlackAccess_1 = grantSlackAccess;
      }
      toString() {
        return 'Data(grantSlackAccess=' + this.grantSlackAccess_1 + ')';
      }
      hashCode() {
        return this.grantSlackAccess_1 == null ? 0 : getBooleanHashCode(this.grantSlackAccess_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.grantSlackAccess_1 == other.grantSlackAccess_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.ADAPTER_1 = obj(Data_getInstance());
        this.ROOT_FIELD_1 = (new (Builder())('data', Companion_getInstance().type_1)).selections_gjxob8_k$(GrantSlackAccessMutationSelections_getInstance().__root_1).build_1k0s4u_k$();
        this.OPERATION_ID_1 = 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
        this.OPERATION_NAME_1 = 'grantSlackAccess';
      }
      get_OPERATION_DOCUMENT_t250nw_k$() {
        return 'mutation grantSlackAccess($input: GrantSlackAccessInput!) { grantSlackAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var GrantSlackAccessMutationClass;
function GrantSlackAccessMutation() {
  if (GrantSlackAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.input_1 = input;
      }
      operationId_2580de_k$() {
        return 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
      }
      operationId() {
        return this.operationId_2580de_k$();
      }
      document_e91o2j_k$() {
        return Companion_getInstance_0().get_OPERATION_DOCUMENT_t250nw_k$();
      }
      operationName_1injiq_k$() {
        return 'grantSlackAccess';
      }
      operationName() {
        return this.operationName_1injiq_k$();
      }
      serializeVariables_bugef7_k$(writer, customScalarAdapters, withDefaultValues) {
        GrantSlackAccessMutation_VariablesAdapter_instance.serializeVariables_uggtg9_k$(writer, this, customScalarAdapters, withDefaultValues);
      }
      adapter_j0zdtd_k$() {
        return Companion_getInstance_0().ADAPTER_1;
      }
      toString() {
        return 'GrantSlackAccessMutation(input=' + this.input_1.toString() + ')';
      }
      hashCode() {
        return this.input_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessMutation()))
          return false;
        if (!this.input_1.equals(other.input_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessMutation', VOID, VOID, [Mutation()]);
    GrantSlackAccessMutationClass = $;
  }
  return GrantSlackAccessMutationClass;
}
//region block: exports
export {
  Data as Data1rorqhenzwzbc,
  GrantSlackAccessMutation as GrantSlackAccessMutationfs5xfcp7iisz,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutation.mjs.map
